export function buildProjectBridgeImportSummaryCards({ importRecord, latestRunStatus }) {
    const latestGenerationStatus = normalizeRunStatus(latestRunStatus)

    return [
        {
            key: "report-date",
            title: "Report Date",
            total: importRecord?.reportDate || "Unknown",
            color: "info",
            status: null,
        },
        {
            key: "schedules-imported",
            title: "Schedules Imported",
            total: `${Number(importRecord?.reportItemCount || 0)}`,
            color: "primary",
            status: null,
        },
        {
            key: "source-file",
            title: "Source File",
            total: importRecord?.sourceFileName || "—",
            color: "warning",
            status: null,
        },
        {
            key: "latest-generation",
            title: "Latest Generation",
            total: getProjectBridgeLatestGenerationLabel(latestGenerationStatus),
            color: getProjectBridgeLatestGenerationCardColor(latestGenerationStatus),
            status: latestGenerationStatus,
        },
    ]
}

export function getProjectBridgeLatestGenerationCardColor(status) {
    if (status === "complete") return "success"
    if (status === "processing") return "warning"
    if (status === "error") return "error"
    return "info"
}

function getProjectBridgeLatestGenerationLabel(status) {
    if (status === "complete") return "Ready"
    if (status === "processing") return "Processing"
    if (status === "error") return "Error"
    return "Not Started"
}

function normalizeRunStatus(status) {
    if (status === "RUNNING") return "processing"
    if (status === "COMPLETED") return "complete"
    if (status === "ERROR") return "error"
    if (status === "QUEUED") return "processing"
    return "pending"
}
